// extracted by mini-css-extract-plugin
module.exports = {"invite":"e_dA","link":"e_eA"};